/* unplugin-vue-components disabled */import { render } from "./excellentVideo.vue?vue&type=template&id=17e7cced&scoped=true"
import script from "./excellentVideo.vue?vue&type=script&lang=js"
export * from "./excellentVideo.vue?vue&type=script&lang=js"

import "./excellentVideo.vue?vue&type=style&index=0&id=17e7cced&lang=scss&scoped=true"

import exportComponent from "/root/.jenkins/workspace/高保障-门户山农大-前端页面-saas/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17e7cced"]])

export default __exports__